import { motion } from "framer-motion";
import { PageHeader, PolicyCard, PolicyRow, ContactNudge } from "../components/PolicyHelpers";

export default function CancellationPolicy() {
  return (
    <div className="bg-white" style={{ paddingTop: 64 }}>
      <div className="max-w-2xl mx-auto px-4 py-12">

        <PageHeader
          eyebrow="Town Square Arena"
          title="Cancellation & Refund Policy"
          subtitle="How to cancel a booking and what to expect for refunds."
        />

        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45, delay: 0.08 }}>
          <PolicyCard>
            <PolicyRow icon="✓" iconBg="#dcfce7" iconBorder="#86efac" iconColor="#16a34a" title="Cancellations 6+ hours before the slot">
              Eligible for a <span className="text-green-600 font-semibold">full refund</span>
            </PolicyRow>
            <PolicyRow icon="✕" iconBg="#fef2f2" iconBorder="#fca5a5" iconColor="#ef4444" title="Cancellations less than 6 hours before the slot">
              Not eligible for a refund
            </PolicyRow>
            <PolicyRow icon="⏱" iconBg="#fffbeb" iconBorder="#fde68a" iconColor="#f59e0b" title="Refund timeline">
              Processed within <span className="text-black font-medium">5–7 business days</span> to the original payment method
            </PolicyRow>

            <div className="px-5 py-5">
              <p className="text-xs font-black text-black/35 uppercase tracking-[0.15em] mb-3">How to Request a Cancellation</p>
              <div className="space-y-2.5">
                <a
                  href="https://wa.me/919133303044"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 p-3 rounded-xl border border-black/8 bg-white hover:border-green-300 hover:bg-green-50 transition-all group"
                >
                  <span className="text-xl">💬</span>
                  <div>
                    <p className="text-black font-semibold text-sm group-hover:text-green-700 transition-colors">WhatsApp</p>
                    <p className="text-black/40 text-xs">+91 91333 03044</p>
                  </div>
                  <span className="ml-auto text-black/20 group-hover:text-green-400 text-xs">→</span>
                </a>
                <a
                  href="mailto:support@townsquarearena.com"
                  className="flex items-center gap-3 p-3 rounded-xl border border-black/8 bg-white hover:border-[#f59e0b]/50 hover:bg-amber-50 transition-all group"
                >
                  <span className="text-xl">✉️</span>
                  <div>
                    <p className="text-black font-semibold text-sm group-hover:text-[#b45309] transition-colors">Email</p>
                    <p className="text-black/40 text-xs">support@townsquarearena.com</p>
                  </div>
                  <span className="ml-auto text-black/20 group-hover:text-[#f59e0b] text-xs">→</span>
                </a>
              </div>
            </div>
          </PolicyCard>
        </motion.div>

        <ContactNudge />
      </div>
    </div>
  );
}
